// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scoreboard-container {
    background: rgba(0, 0, 0, 0.7);
    border-radius: 8px;
    padding: 20px;
    margin: 20px 0;
    color: #fff;
    box-shadow: 0 4px 15px rgba(255, 119, 0, 0.3);
    border: 1px solid rgba(255, 119, 0, 0.2);
    backdrop-filter: blur(5px);
}

.scoreboard-container h3 {
    color: #ff7700;
    text-align: center;
    font-size: 1.3rem;
    margin-top: 0;
    margin-bottom: 20px;
}

.loading-indicator, .error-message, .no-data-message {
    text-align: center;
    padding: 15px;
    border-radius: 6px;
}

.loading-indicator {
    background: rgba(255, 255, 255, 0.1);
    color: #ddd;
}

.error-message {
    background: rgba(255, 0, 0, 0.2);
    color: #ffcccc;
}

.no-data-message {
    background: rgba(255, 255, 255, 0.1);
    color: #ddd;
    font-style: italic;
}

.scoreboard-table-container {
    max-height: 300px;
    overflow-y: auto;
    margin-top: 10px;
    padding-right: 5px;
}

.scoreboard-table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
}

.scoreboard-table th {
    padding: 10px;
    text-align: left;
    border-bottom: 2px solid rgba(255, 119, 0, 0.5);
    color: #ff9d4d;
    font-weight: 600;
    position: sticky;
    top: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1;
}

.scoreboard-table td {
    padding: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.scoreboard-table tr:last-child td {
    border-bottom: none;
}

.scoreboard-table tr:hover {
    background-color: rgba(255, 255, 255, 0.05);
}

.current-user-row {
    background-color: rgba(255, 119, 0, 0.2) !important;
    font-weight: 600;
}

.rank-cell {
    width: 60px;
    text-align: center;
}

.name-cell {
    text-align: left;
}

.score-cell {
    width: 100px;
    text-align: center;
    font-weight: 600;
    color: #ff9d4d;
}

.rank-badge {
    font-size: 1.2rem;
}

.rank-number {
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 24px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.1);
    text-align: center;
}

.you-indicator {
    font-style: italic;
    opacity: 0.8;
    font-weight: normal;
}

@media (max-width: 480px) {
    .scoreboard-container {
        padding: 15px;
    }
    
    .scoreboard-table th, .scoreboard-table td {
        padding: 8px 5px;
        font-size: 0.9rem;
    }
    
    .rank-cell {
        width: 40px;
    }
    
    .score-cell {
        width: 70px;
    }
}

.scoreboard-tabs {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
    gap: 10px;
}

.tab-button {
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 119, 0, 0.3);
    color: #fff;
    padding: 8px 16px;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 0.9rem;
    font-weight: 500;
}

.tab-button:hover {
    background-color: rgba(255, 119, 0, 0.3);
}

.tab-button.active {
    background-color: rgba(255, 119, 0, 0.6);
    border-color: rgba(255, 119, 0, 0.8);
    font-weight: 600;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
} `, "",{"version":3,"sources":["webpack://./src/styles/Scoreboard.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,WAAW;IACX,6CAA6C;IAC7C,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,+CAA+C;IAC/C,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,aAAa;IACb,iDAAiD;AACrD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,mDAAmD;IACnD,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,0CAA0C;IAC1C,wCAAwC;IACxC,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,gBAAgB;IAChB,wCAAwC;AAC5C","sourcesContent":[".scoreboard-container {\n    background: rgba(0, 0, 0, 0.7);\n    border-radius: 8px;\n    padding: 20px;\n    margin: 20px 0;\n    color: #fff;\n    box-shadow: 0 4px 15px rgba(255, 119, 0, 0.3);\n    border: 1px solid rgba(255, 119, 0, 0.2);\n    backdrop-filter: blur(5px);\n}\n\n.scoreboard-container h3 {\n    color: #ff7700;\n    text-align: center;\n    font-size: 1.3rem;\n    margin-top: 0;\n    margin-bottom: 20px;\n}\n\n.loading-indicator, .error-message, .no-data-message {\n    text-align: center;\n    padding: 15px;\n    border-radius: 6px;\n}\n\n.loading-indicator {\n    background: rgba(255, 255, 255, 0.1);\n    color: #ddd;\n}\n\n.error-message {\n    background: rgba(255, 0, 0, 0.2);\n    color: #ffcccc;\n}\n\n.no-data-message {\n    background: rgba(255, 255, 255, 0.1);\n    color: #ddd;\n    font-style: italic;\n}\n\n.scoreboard-table-container {\n    max-height: 300px;\n    overflow-y: auto;\n    margin-top: 10px;\n    padding-right: 5px;\n}\n\n.scoreboard-table {\n    width: 100%;\n    border-collapse: collapse;\n    border-spacing: 0;\n}\n\n.scoreboard-table th {\n    padding: 10px;\n    text-align: left;\n    border-bottom: 2px solid rgba(255, 119, 0, 0.5);\n    color: #ff9d4d;\n    font-weight: 600;\n    position: sticky;\n    top: 0;\n    background: rgba(0, 0, 0, 0.8);\n    z-index: 1;\n}\n\n.scoreboard-table td {\n    padding: 10px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.scoreboard-table tr:last-child td {\n    border-bottom: none;\n}\n\n.scoreboard-table tr:hover {\n    background-color: rgba(255, 255, 255, 0.05);\n}\n\n.current-user-row {\n    background-color: rgba(255, 119, 0, 0.2) !important;\n    font-weight: 600;\n}\n\n.rank-cell {\n    width: 60px;\n    text-align: center;\n}\n\n.name-cell {\n    text-align: left;\n}\n\n.score-cell {\n    width: 100px;\n    text-align: center;\n    font-weight: 600;\n    color: #ff9d4d;\n}\n\n.rank-badge {\n    font-size: 1.2rem;\n}\n\n.rank-number {\n    display: inline-block;\n    width: 24px;\n    height: 24px;\n    line-height: 24px;\n    border-radius: 50%;\n    background-color: rgba(255, 255, 255, 0.1);\n    text-align: center;\n}\n\n.you-indicator {\n    font-style: italic;\n    opacity: 0.8;\n    font-weight: normal;\n}\n\n@media (max-width: 480px) {\n    .scoreboard-container {\n        padding: 15px;\n    }\n    \n    .scoreboard-table th, .scoreboard-table td {\n        padding: 8px 5px;\n        font-size: 0.9rem;\n    }\n    \n    .rank-cell {\n        width: 40px;\n    }\n    \n    .score-cell {\n        width: 70px;\n    }\n}\n\n.scoreboard-tabs {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 15px;\n    gap: 10px;\n}\n\n.tab-button {\n    background-color: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(255, 119, 0, 0.3);\n    color: #fff;\n    padding: 8px 16px;\n    border-radius: 20px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    font-size: 0.9rem;\n    font-weight: 500;\n}\n\n.tab-button:hover {\n    background-color: rgba(255, 119, 0, 0.3);\n}\n\n.tab-button.active {\n    background-color: rgba(255, 119, 0, 0.6);\n    border-color: rgba(255, 119, 0, 0.8);\n    font-weight: 600;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
